// Copyright (c) 2018, Picsa Advisory Services (Pty) Ltd. All rights reserved.

import React from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'

import {
  LabelledDetail,
  Grid
} from '../'

import { showAsCurrency } from '../../utils'


export const Payslip = ({ title, date, basicGross, totalGross, totalDeductions }) => (
  <div className='slds-m-top_small' style={{ backgroundColor: '#F5F5F5' }}>
    <div className='u-font-size-larger slds-p-left_x-small slds-m-bottom_x-small' style={{ backgroundColor: '#ECECEC' }}>
      Payday:
      &ensp;
      <span className='slds-text-color_weak slds-size_2-of-3'>
        {moment(date).format('D MMMM YYYY')}
      </span>
    </div>
    <Grid
      columns={3}
      items={[
        <LabelledDetail
          label='Basic gross'
          detail={showAsCurrency('R', basicGross)}
          className='slds-m-bottom_small'
        />,
        <LabelledDetail
          label='Total gross'
          detail={showAsCurrency('R', totalGross)}
          className='slds-m-bottom_small'
        />,
        <LabelledDetail
          label='Total deductions'
          detail={showAsCurrency('R', totalDeductions)}
          className='slds-m-bottom_small'
        />
      ]}
      className='slds-m-bottom_large slds-p-left_small'
    />
  </div>
)

Payslip.propTypes = {
  date: PropTypes.string,
  basicGross: PropTypes.number,
  totalGross: PropTypes.number,
  totalDeductions: PropTypes.number
}



// WEBPACK FOOTER //
// ./src/components/loanapplication-income/Payslip.js